import { render, staticRenderFns } from "./back-deliveryreceipt-batchlist.vue?vue&type=template&id=12aef5e0&"
import script from "./back-deliveryreceipt-batchlist.vue?vue&type=script&lang=ts&"
export * from "./back-deliveryreceipt-batchlist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports